import { useMutation } from "@apollo/client";
import {
  CreateClientServiceProfileDocument,
  ClientServiceProfileByFiltersDocument,
  ClientServiceProfileStatusesEnum,
  ClientServiceProfileEventsEnum,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import {
  ServiceProfileServiceIdMap,
  type ServiceProfileType,
  type PetProfileAttributes,
  type EldercareAttributes,
  type BabySitterAttributes,
} from "@/containers/profile/service-profile/lib";

export type CreateServiceProfileInput = {
  type: ServiceProfileType;
  name: string;
  profileAttributes:
    | PetProfileAttributes
    | EldercareAttributes
    | BabySitterAttributes;
  primary: boolean;
};

export const useCreateClientServiceProfileMutation = () => {
  const [mutate, rest] = useMutation(CreateClientServiceProfileDocument, {
    refetchQueries: [
      {
        query: ClientServiceProfileByFiltersDocument,
        variables: {
          filters: {
            clientId: useAuthState.getState().data.userInfo.id,
            status: ClientServiceProfileStatusesEnum.Active,
            limit: 3,
          },
        },
      },
    ],
  });

  const createProfile = ({
    type,
    name,
    profileAttributes,
    primary,
  }: CreateServiceProfileInput) => {
    const clientId = useAuthState.getState().data.userInfo.id;
    const serviceId = ServiceProfileServiceIdMap[type];

    return mutate({
      variables: {
        input: {
          name,
          profileAttributes,
          primary,
          serviceId,
          clientId,
          event: ClientServiceProfileEventsEnum.Activate,
        },
      },
    });
  };

  return { createProfile, ...rest };
};
